/* RESPONSIBLE TEAM: team-actions */
import EmbercomAdapter from 'embercom/lib/adapter/embercom-adapter';

export default EmbercomAdapter.extend({
  pathForType() {
    return 'oauth/connect';
  },
});
